import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronUp, ShieldCheck } from 'lucide-react';

interface FacilitaRgpdClauseProps {
  defaultExpanded?: boolean;
}

export function FacilitaRgpdClause({ defaultExpanded = false }: FacilitaRgpdClauseProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className="border rounded-md bg-gray-50/50 overflow-hidden">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-3 py-2 text-[10px] text-gray-500 hover:bg-gray-100/50 transition-colors"
      >
        <span className="flex items-center gap-1.5">
          <ShieldCheck className="h-3 w-3 text-gray-400" />
          <span className="font-medium text-gray-600">Información sobre protección de datos</span>
        </span>
        {expanded ? (
          <ChevronUp className="h-3 w-3 text-gray-400" />
        ) : (
          <ChevronDown className="h-3 w-3 text-gray-400" />
        )}
      </button>
      {expanded && (
        <div className="px-3 pb-3 border-t border-gray-100">
          <p className="text-[10px] text-gray-600 leading-relaxed mt-2">
            En GESTORIA LITE tratamos la información que nos facilita con el fin de prestarles el
            servicio solicitado y realizar la facturación del mismo. Los datos proporcionados se
            conservarán mientras se mantenga la relación comercial o durante el tiempo necesario para
            cumplir con las obligaciones legales y atender las posibles responsabilidades que pudieran
            derivar del cumplimiento de la finalidad para la que los datos fueron recabados. Los datos
            no se cederán a terceros salvo en los casos en que exista una obligación legal. Usted tiene
            derecho a obtener información sobre si en GESTORIA LITE estamos tratando sus datos
            personales, por lo que puede ejercer sus derechos de acceso, rectificación, supresión y
            portabilidad de datos y oposición y limitación a su tratamiento ante GESTORIA LITE,
            Barcelona, Calella, Calle Sant Antoni 68, 1-2, 08370 o en la dirección de correo
            electrónico{' '}
            <a href="mailto:legal@gestorialite.com" className="text-primary hover:underline">
              legal@gestorialite.com
            </a>
            , adjuntando copia de su DNI o documento equivalente. Asimismo, y especialmente cuando
            considere que no ha obtenido satisfacción plena en el ejercicio de sus derechos, podrá
            presentar una reclamación ante la autoridad nacional de control dirigiéndose a estos
            efectos a la Agencia Española de Protección de Datos, C/ Jorge Juan, 6 – 28001 Madrid.
          </p>
          <div className="mt-2">
            <Link to="/privacy" className="text-[10px] text-primary hover:underline">
              Consultar Política de Privacidad completa
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
